import { Skeleton, Typography } from "antd";
import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  text-transform: capitalize;

  button {
    text-transform: capitalize;
  }
`;

export const Title = styled(Typography.Title)``;

export const TitleSkeleton = styled(Skeleton).attrs({
  paragraph: false,
})`
  &.ant-skeleton {
    .ant-skeleton-content {
      .ant-skeleton-title {
        height: 4rem;
        margin-bottom: 2.5rem;
        width: 40%;
      }
    }
  }
`;
